import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

import Searchbar from '../../../../components/Searchbar';
import { config } from '../../../../config/index';

import { GET, newFetch } from '../../../../helpers/fetch';

import placeholderImage from '../../../../assets/images/placeholder.jpg';
import SpringLoader from '../../../../components/SpringLoader/SpringLoader.js';
import AlertService from '../../../../components/SweetAlert';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
const { API_URL } = config;

const Admins = () => {
  const token = localStorage.getItem('token');
  const [admins, setAdmins] = useState([]);
  const [filteredAdmins, setFilteredAdmins] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(true);

  const checkboxHandler = (e) => {
    if (e.target.checked) {
      let updatedSelectedIds = [...selectedIds];

      updatedSelectedIds.push(parseInt(e.target.value));
      setSelectedIds(updatedSelectedIds);
    } else {
      let updatedSelectedIds = [...selectedIds].filter(
        (id) => id !== parseInt(e.target.value),
      );

      setSelectedIds(updatedSelectedIds);
    }
  };

  useEffect(() => {}, [filteredAdmins]);

  const checkboxAllOn = (e) => {
    if (e.target.checked) {
      let admin_ids = filteredAdmins.map((admin) => admin.id);
      setSelectedIds(admin_ids);
    } else {
      setSelectedIds([]);
    }
  };

  const searchHandler = (e) => {
    let filtered = [...admins].filter((admin) => {
      let name = `${admin.first_name} ${admin.last_name}`;
      return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
    });
    setFilteredAdmins(filtered);
  };

  const deleteAdmin = async (id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete this Admin?',
      )
    ) {
      const url = `${API_URL}/admin/admins/${id}`;

      try {
        let response = await fetch(url, {
          mode: 'cors',
          method: 'DELETE',
          withCredentials: true,
          headers: {
            Authorization: token,
          },
        });

        let data = await response.json();
        if (response.ok) {
          ToastUtil.success('Admin successfully deleted!');
          window.location.reload();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const deleteSelectedHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete these Admins?',
      )
    ) {
      var failed = [];
      for (let id of selectedIds) {
        const url = `${API_URL}/admin/admins/${id}`;

        let response = await fetch(url, {
          mode: 'cors',
          method: 'DELETE',
          withCredentials: true,
          headers: {
            Authorization: token,
          },
        });

        let data = await response.json();
        if (!response.ok) {
          // throw new Error(response.statusText)
          failed.push(id);
        }
      }

      if (failed.length > 0) {
        return ToastUtil.error('Failed to delete admins that have data!');
      }

      ToastUtil.success('Admins successfully deleted!');
      window.location.reload();
    }
  };

  const fetchAdmins = async () => {
    setLoading(true);
    try {
      let response = await newFetch(GET, '/admin/admins');
      if (response.success) {
        setAdmins(response.data);
        setFilteredAdmins(JSON.parse(JSON.stringify(response.data)));
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  return (
    <div
      className="container-fluid"
      style={{ paddingLeft: '2rem', paddingRight: '2rem' }}
    >
      <div className="border-bottom pb-3 py-4 d-flex align-items-center">
        <h6 className="flex-grow-1" style={{ color: '#A6478E' }}>
          Admin Management
        </h6>
        <NavLink
          to="/admins/admin/add"
          className="text-decoration-none"
          style={{ color: 'inherit' }}
        >
          <button
            className="btn btn-outline-brand ms-3 mt-2 adjust-fs adjust-shadow"
            style={{ width: '200px' }}
          >
            Add New
          </button>
        </NavLink>
      </div>
      <div className="d-flex flex-row align-items-center py-3">
        <h6 className="flex-grow-1">Admin ({filteredAdmins.length})</h6>
        <Searchbar
          search={(e) => searchHandler(e)}
          placeholder="Search admin"
        />
      </div>
      <div className="table-responsive rounded shadow bg-white">
        <table className="table table-borderless mb-0">
          <thead className="border-bottom">
            <tr>
              <th className="py-3 text-muted fw-normal">
                <div className="form-check">
                  <input
                    className="form-check-input position-static"
                    onChange={checkboxAllOn}
                    type="checkbox"
                  />
                </div>
              </th>
              {selectedIds.length > 0 ? (
                <React.Fragment>
                  <th className="py-3 text-muted fw-normal">Name</th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-danger fw-normal">
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={deleteSelectedHandler}
                    >
                      Delete
                    </div>
                  </th>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <th className="py-3 text-muted fw-normal">Name</th>
                  <th className="py-3 text-muted fw-normal">Employee ID</th>
                  <th className="py-3 text-muted fw-normal">Email</th>
                  <th className="py-3 text-muted fw-normal">Role</th>
                  <th className="py-3 text-muted fw-normal">Client</th>
                  <th className="py-3 text-muted fw-normal"></th>
                </React.Fragment>
              )}
            </tr>
          </thead>
          <tbody>
            {filteredAdmins.length > 0 ? (
              filteredAdmins.map((admin) => {
                return (
                  <tr key={admin.id} className="border-bottom">
                    <td>
                      <div className="form-check">
                        <input
                          className="form-check-input position-static"
                          type="checkbox"
                          checked={selectedIds.some((id) => id === admin.id)}
                          value={admin.id}
                          onChange={checkboxHandler}
                        />
                      </div>
                    </td>
                    <td>
                      <Link
                        className="d-flex align-items-center"
                        to={`/admins/${admin.id}`}
                        style={{ color: 'inherit', textDecoration: 'none' }}
                      >
                        <div
                          className="rounded-circle border me-3"
                          style={{
                            position: 'relative',
                            width: '30px',
                            height: '30px',
                            borderRadius: '50%',
                            overflow: 'hidden',
                          }}
                        >
                          <img
                            src={admin.photo ? admin.photo : placeholderImage}
                            alt="user"
                            style={{
                              maxWidth: '100%',
                            }}
                          />
                        </div>
                        <strong
                          className={
                            !admin.active ? 'text-danger' : 'text-muted'
                          }
                        >
                          {admin.first_name} {admin.last_name}
                        </strong>
                      </Link>
                    </td>
                    <td className="text-muted">{admin.employee_no}</td>
                    <td className="text-muted">{admin.email}</td>
                    <td className="text-muted">
                      <span
                        className={`badge rounded-pill ${
                          Number(admin.is_super) === 1
                            ? `bg-danger`
                            : Number(admin.is_ops) === 1
                              ? `bg-primary`
                              : admin.type === 'client'
                                ? `bg-warning`
                                : `bg-secondary`
                        } me-2 p-2`}
                      >
                        {Number(admin.is_super) === 1
                          ? 'Super Admin'
                          : Number(admin.is_ops) === 1
                            ? 'Ops Admin'
                            : admin.type === 'client'
                              ? 'Client Admin'
                              : 'Admin'}
                      </span>
                    </td>
                    <td className="text-muted">
                      {admin?.client_admins && admin.client_admins.length > 0
                        ? admin.client_admins
                            .map((ca) => ca?.client?.name || '')
                            .join(', ')
                        : '--'}
                    </td>
                    <td className="text-center">
                      <div
                        style={{ cursor: 'pointer' }}
                        className="dropdown custom-dropdown"
                      >
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i
                            className="fas fa-ellipsis-h adjust-fs"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          ></i>
                        </button>
                        <div
                          className="dropdown-menu dropdown-menu-right"
                          style={{ width: '150px' }}
                        >
                          <Link
                            to={`/admins/admin/${admin.id}/edit`}
                            style={{ cursor: 'pointer' }}
                            className="dropdown-item border-bottom pb-2 adjust-fs"
                          >
                            Edit
                          </Link>
                          <div
                            onClick={() => deleteAdmin(admin.id)}
                            style={{ cursor: 'pointer' }}
                            className="dropdown-item pt-2 adjust-fs"
                          >
                            Delete
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  {loading ? (
                    <div className="springloader-holder">
                      <SpringLoader></SpringLoader>
                    </div>
                  ) : (
                    <div className="text-center text-muted my-3 pb-4">
                      <i>No results</i>
                    </div>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Admins;
